import React, { useState, useRef } from 'react';

// Lib
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import clsx from 'clsx';

// Styles
import './Tabs.scss';

type Props = {
  children: React.ReactNode;
  defaultActiveTab?: string;
  settings: any;
};

const Tabs = ({ ...props }: Props) => {
  const { children, defaultActiveTab, settings } = props;
  const {
    heading_type_tab,
    active_tab_border_color,
    active_tab_color,
    inactive_tab_color,
    tab_button_padding_top_desktop,
    tab_button_padding_bottom_desktop,
    tab_button_padding_left_right_desktop,
    tab_button_padding_top_mobile,
    tab_button_padding_bottom_mobile,
    tab_button_padding_left_right_mobile
  } = settings.section;

  const tabs = React.Children.toArray(children)
    .filter((child: React.ReactNode) => React.isValidElement(child))
    .map((tab: React.ReactNode) => React.cloneElement(tab, {}));

  // States
  const [activeTabTitle, setActiveTabTitle] = useState(
    defaultActiveTab ? defaultActiveTab : tabs[0].props.title
  );

  // Refs
  const contentRef = useRef(null);

  const activeTab = tabs.find((tab) => tab.props.title === activeTabTitle);

  return (
    <div className='tabs'>
      {/* Navigation */}
      {tabs.length > 1 && (
        <div className='tabs__nav'>
          {tabs.map((tab) => {
            return (
              <div
                key={tab.props.title}
                className={clsx([
                  `tabs__nav-item ${heading_type_tab} pt-[${tab_button_padding_top_mobile}px] lg:pt-[${tab_button_padding_top_desktop}px] pb-[${tab_button_padding_bottom_mobile}px] lg:pb-[${tab_button_padding_bottom_desktop}px] px-[${tab_button_padding_left_right_mobile}px] lg:px-[${tab_button_padding_left_right_desktop}px]`,
                  {
                    'tabs__nav-item--active': tab.props.title === activeTabTitle
                  }
                ])}
                style={
                  {
                    '--active-border': active_tab_border_color,
                    '--active-text': active_tab_color,
                    '--inactive-text': inactive_tab_color
                  } as React.CSSProperties
                }
                onClick={() => setActiveTabTitle(tab.props.title)}
              >
                {tab.props.icon && <img src={tab.props.icon} />}
                <span>{tab.props.title}</span>
              </div>
            );
          })}
        </div>
      )}

      {/* Content */}
      <div className='tabs__contents'>
        <SwitchTransition>
          <CSSTransition
            key={activeTabTitle}
            nodeRef={contentRef}
            timeout={300}
            classNames='fade-up'
          >
            <div
              ref={contentRef}
              className={`tabs__content`}
            >
              {activeTab}
            </div>
          </CSSTransition>
        </SwitchTransition>
      </div>
    </div>
  );
};

export default Tabs;
